import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import MenuItems from "./menuItems";

const feature = "menuItems";

const InitialState = Record({
  menuItems: new MenuItems()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function MenuItemsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.menuItems
    ) {
      state = state.updateIn(["menuItems", "entities"], map =>
        map.mergeDeep(action.payload.entities.menuItems));
    }
  }

  switch (action.type) {
    case actions.PATCH_MENU_ITEM: {
      return state.setIn(["menuItems", "loading"], true);
    }
    case actions.PATCH_MENU_ITEM_SUCCESS: {
      return state.setIn(["menuItems", "loading"], false);
    }
    case actions.PATCH_MENU_ITEM_ERROR: {
      return state.setIn(["menuItems", "loading"], false);
    }

    case actions.DELETE_MENU_ITEM: {
      return state.deleteIn(["menuItems", "entities", action.payload.uid]);
    }

    case actions.SET_IS_REMOVE_MENU_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["menuItems", "isRemoveModalVisible"],
        action.payload.value
      );
    }
    case actions.SET_IS_EDIT_MENU_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["menuItems", "isEditModalVisible"],
        action.payload.value
      );
    }
    case actions.SET_IS_ADD_MENU_ITEM_MODAL_VISIBLE: {
      return state.setIn(
        ["menuItems", "isAddModalVisible"],
        action.payload.value
      );
    }

  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/menuItems/reducer.js